import { computed, inject, Injectable, Signal } from '@angular/core';
import { PurchaseListStore } from '../../../../stores/purchase-list.store';
import { ProductListItem } from '../../../../models/product-list/productListItem';
import { TunnelCartLine } from '../../common/purchase-list/models/tunnel-cart-line';
import { TunnelCartService } from '../../common/purchase-list/services/tunnel-cart.service';

/**
 * Liste d'achat du configurateur panier. S'appuie sur le {@link PurchaseListStore}, partagé avec le
 * parcours mobile.
 */
@Injectable({ providedIn: 'root' })
export class BasketCartService extends TunnelCartService {
  private readonly purchaseListStore = inject(PurchaseListStore);

  readonly lines: Signal<TunnelCartLine[]> = computed(() =>
    this.purchaseListStore.displayItems().map(item => ({
      ean: item.product.ean,
      label: item.product.name,
      price: item.product.price,
      quantity: item.amount,
      imageSrc: item.product.imgPaths?.[0],
    }))
  );

  readonly total: Signal<number> = this.purchaseListStore.totalListPrice;

  readonly totalWithDiscount: Signal<number> = this.purchaseListStore.totalListPriceWithDiscount;

  /** La liste d'achat du panier reste modifiable jusqu'à l'envoi du devis. */
  readonly isLocked: Signal<boolean> = computed(() => false);

  quantityOf(ean: string): number {
    return this.purchaseListStore.displayItems().find(item => item.product.ean === ean)?.amount ?? 0;
  }

  setQuantity(ean: string, quantity: number): void {
    if (quantity <= 0) {
      this.purchaseListStore.removeFromPurchaseList(ean);
      return;
    }

    const product = this.purchaseListStore.displayItems().find(item => item.product.ean === ean)?.product;
    if (!product) {
      return;
    }

    // Le store résout lui-même les produits d'un lot : les signaux se mettent à jour au fil de l'eau.
    void this.purchaseListStore.addToPurchaseList({ product: product, amount: quantity, wasManuallyAdded: true }, true);
  }

  addProduct(product: ProductListItem, quantity: number = 1): void {
    void this.purchaseListStore.addToPurchaseList(
      { product: product, amount: quantity, wasManuallyAdded: true },
      true
    );
  }
}
